export default __webpack_public_path__ + "static/logoNestor-e96a90f6b74148c685f70b77e97fab84.png";